export default __webpack_public_path__ + "static/media/puebla.ca96811b.jpg";